<div class="flow-detail-wrapper">
  @if (error) {
    <div class="example-box">
      {{error | json}}
    </div>
  }

  <!-- Toolbar uses the global pill-button styles (.app-pill-btn) so both popup
  and route-embedded modes share visual language with the rest of the app.
  Hidden entirely when no buttons would render (e.g. Connector in route
  mode: Save is read-only, Cancel needs a popup, Advanced Edit is Flow-only). -->
  @if (hasToolbarButtons) {
    <div class="flow-detail__toolbar">
      @if (editorType?.toString() === 'Flow' || editorType?.toString() === 'FlowAdvanced' || editorType?.toString() === 'Connection') {
        <button type="button"
          class="app-pill-btn app-pill-btn--primary"
          (click)="onSaveClick()">
          <i class="ms-Icon ms-Icon--Save" aria-hidden="true"></i>
          <span>Save</span>
        </button>
      }
      <!-- Cancel only when hosted in a Kendo popup; route pages use the back
      button in the page header for navigation. -->
      @if (windowRef) {
        <button type="button"
          class="app-pill-btn"
          (click)="close()">
          <i class="ms-Icon ms-Icon--ChromeClose" aria-hidden="true"></i>
          <span>Cancel</span>
        </button>
      }
      @if (editorType?.toString() === 'Flow') {
        <button type="button"
          class="app-pill-btn"
          (click)="advanced()">
          <i class="ms-Icon ms-Icon--PageEdit" aria-hidden="true"></i>
          <span>Advanced Edit</span>
        </button>
      }
      @if (editorType?.toString() === 'FlowAdvanced') {
        <button type="button"
          class="app-pill-btn"
          (click)="definitionOnly()">
          <i class="ms-Icon ms-Icon--Code" aria-hidden="true"></i>
          <span>Definition Only</span>
        </button>
      }
    </div>
  }

  <div class="flow-detail__editor">
    <ngx-monaco-editor class="monaco-editor" [options]="editorOptions" [(ngModel)]="code" (onInit)="onInit($event)"></ngx-monaco-editor>
  </div>

  @if (!this.ready) {
    <div class="k-i-loading"></div>
  }
</div>
